"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePlanBodySchema = exports.CreatePlanBodySchema = exports.ListPlansResponseSchema = exports.ListPlansQuerySchema = exports.ListActiveBudgetPlanResponseSchema = exports.ListActiveBudgetPlanQuerySchema = exports.AllocatedBudgetPlanResponseSchema = exports.PlanResponseSchema = exports.PlanResponseFields = exports.BudgetPlanDetailsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.BudgetPlanDetailsSchema = (0, core_1.StrictObject)({
    weekdayOverspend: (0, core_1.StrictObject)({
        monday: core_1.OverPercentageSchema,
        tuesday: core_1.OverPercentageSchema,
        wednesday: core_1.OverPercentageSchema,
        thursday: core_1.OverPercentageSchema,
        friday: core_1.OverPercentageSchema,
        saturday: core_1.OverPercentageSchema,
        sunday: core_1.OverPercentageSchema,
    }),
});
const BudgetPlanFields = {
    campaignId: core_1.IdSchema,
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    totalBudget: core_1.MoneySchema,
    details: exports.BudgetPlanDetailsSchema,
    status: ruby_1.BudgetPlanStatusSchema,
    policy: ruby_1.BudgetPlanPolicySchema,
    method: ruby_1.BudgetPlanMethodSchema,
};
exports.PlanResponseFields = {
    ...BudgetPlanFields,
    ...core_1.ModelMetaFields,
};
exports.PlanResponseSchema = (0, core_1.StrictObject)(exports.PlanResponseFields);
exports.AllocatedBudgetPlanResponseSchema = (0, core_1.StrictObject)({
    ...BudgetPlanFields,
    ...core_1.ModelMetaFields,
    allocations: typebox_1.Type.Array(common_1.BudgetAllocationResponseSchema),
});
exports.ListActiveBudgetPlanQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    at: typebox_1.Type.Optional(core_1.TimestampSchema),
});
exports.ListActiveBudgetPlanResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AllocatedBudgetPlanResponseSchema);
exports.ListPlansQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    includeAllocations: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.ListPlansResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AllocatedBudgetPlanResponseSchema);
exports.CreatePlanBodySchema = (0, core_1.StrictObject)({
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    totalBudget: core_1.MoneySchema,
    details: exports.BudgetPlanDetailsSchema,
    status: ruby_1.BudgetPlanStatusSchema,
    policy: ruby_1.BudgetPlanPolicySchema,
    method: ruby_1.BudgetPlanMethodSchema,
});
exports.UpdatePlanBodySchema = (0, core_1.StrictObject)({
    start: typebox_1.Type.Optional(core_1.TimestampSchema),
    end: typebox_1.Type.Optional(core_1.TimestampSchema),
    totalBudget: typebox_1.Type.Optional(core_1.MoneySchema),
    details: typebox_1.Type.Optional(exports.BudgetPlanDetailsSchema),
    status: typebox_1.Type.Optional(ruby_1.BudgetPlanStatusSchema),
    policy: typebox_1.Type.Optional(ruby_1.BudgetPlanPolicySchema),
    method: typebox_1.Type.Optional(ruby_1.BudgetPlanMethodSchema),
});
